import { type FC } from 'react';

import { Toast } from 'dibs-toaster/exports/Toast.ts';
import { useToastStore } from 'dibs-toaster/exports/useToastStore.ts';

const Toasts: FC = () => {
    const toasts = useToastStore(state => state.toasts);
    const remove = useToastStore(state => state.remove);

    return (
        <>
            {toasts.map(({ id, children, onClose, ...props }) => (
                <Toast
                    key={id}
                    {...props}
                    onClose={() => {
                        onClose?.();
                        remove(id);
                    }}
                >
                    {children}
                </Toast>
            ))}
        </>
    );
};

export { Toasts };
